import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Wrapper } from '../../components/wrapper.component';
import { LineItemTemplate } from 'globals/store/accounts.data';
import { excelFileToRows } from '../../helpers/excel-helpers';
import { createId } from 'globals/helpers/helpers';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';

@Component({
    selector: 'add-line-items-dialog',
    template: `
<dialog-wrapper
  [dialogTitle]="'Import Line Items'"
  [titleHeight]="40"
  [giveMeTwenty]="true"
  [tiny]="true"
  [cancelLeft]="true"
  [disabled]="!lineItems?.length"
  [successLabel]="'IMPORT LINE ITEMS'"
  (submit)="dialogRef.close(lineItems)"
  (cancel)="dialogRef.close()"
  (close)="dialogRef.close()">
    <a class="link" href="assets/files/line-items-template.xlsx">Download template</a>
    <label for="fileInput" class="upload">
      Upload and preview
    </label>
    <input type="file" style="display: none;" id="fileInput" (change)="onFileChange($event)">

  <ng-container *ngIf="!!lineItems?.length">
    <div class="preview-header">Line item preview</div>
    <div class="line-items readOnly">
      <h5 class="header">
        SORT<br/>NUMBER
      </h5>
      <h5 class="header item">
        ITEM
      </h5>
      <h5 class="header">
        UNIT RATE
      </h5>
      <h5 class="header">
        UNIT COST
      </h5>
      <ng-container *ngFor="let item of lineItems;">
        <joi-input 
          [(model)]="item.sortNumber" 
          [fixedWidth]="true"
          [placeholder]="'...'"
          [allowableCharacters]="'0123456789'"
          [disabled]="true"
        ></joi-input>
        <joi-input 
          [(model)]="item.name" 
          [placeholder]="'...'" 
          [disabled]="true"
          [type]="'textarea'" 
          [autoSelect]="false" 
          [returnable]="true"
        ></joi-input>
        <joi-input 
          [(model)]="item.unitRate"
          [fixedWidth]="true"
          [placeholder]="'...'"
          [displayValue]="item.unitRate ? (item.unitRate | prettyNumbers) : null"
          [allowableCharacters]="'0123456789.'"
          [disabled]="true"
        ></joi-input>
        <joi-input 
          [(model)]="item.unitCost"
          [fixedWidth]="true"
          [placeholder]="'...'"
          [displayValue]="item.unitCost ? (item.unitCost | prettyNumbers) : null"
          [allowableCharacters]="'0123456789.'"
          [disabled]="true"
        ></joi-input>
      </ng-container>
    </div>
  </ng-container>
<div class="error" *ngIf="error">{{ error }}</div>

  </dialog-wrapper>
  `,
    styleUrls: ['./add-line-items.scss', './home-budget-line-items.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, PrettyNumbersPipe, JoiInputComponent, CommonModule ]
})


export class AddLineItemsDialog extends Wrapper<AddLineItemsDialog> {

  error = ''
  lineItems: LineItemTemplate[]

  constructor(public dialogRef:MatDialogRef<AddLineItemsDialog>,) {
    super()
  }

  cancel() {
    this.dialogRef.close()
  }

  async onFileChange(evt: any) {
    this.lineItems = null
    this.error = ''
    let targetFile: File;
    if (evt.dataTransfer && evt.dataTransfer.files.length === 1) {
      targetFile = evt.dataTransfer.files[0];
      evt.dataTransfer.files = null
    } else if (evt.target.files && evt.target.files.length === 1) {
      targetFile = evt.target.files[0];
      evt.target.files = null
    } else {
      this.error = 'Cannot use multiple files'
      return
    }
    window['targetFile'] = targetFile
    console.log(targetFile)
    if (!targetFile.name.includes('.xlsx')) {
      this.error = 'Invalid file type'
      return
    }

    const sheet = await excelFileToRows(targetFile)
    console.log(sheet)
    if (!sheet?.length) {
      this.error = 'Invalid file type'
      return
    }
    if (sheet.length < 2) {
      this.error = 'No rows of data'
      return
    }

    const rows = sheet.slice(1)
    try {
      const lineItems: LineItemTemplate[] = rows.filter(r => r && r[0]).map(([ sortNumber, name, unitRate, unitCost ]) => ({ sortNumber, name, unitRate, unitCost, id: createId() }))
      this.lineItems = lineItems
    } catch (error) {
      this.error = 'Something wrong with file'
      return
    }    
  }

}


